import React, { useMemo } from "react";

import type { ServerDataSuccess } from "./route";

import { Disclosure, convertSchemaToHtml } from "@bared/ui";

export interface SeoFeatureDescriptionProps {
  seoFeatureDescription: ServerDataSuccess["seoFeatureDescriptionContent"];
}

export function SeoFeatureDescription({
  seoFeatureDescription,
}: SeoFeatureDescriptionProps) {
  const convertedSeoFeatureDescription: string | TrustedHTML = useMemo(
    () => convertSchemaToHtml(seoFeatureDescription),
    [seoFeatureDescription],
  );

  return (
    <>
      <Disclosure>{convertedSeoFeatureDescription}</Disclosure>
    </>
  );
}
